/**
 * Plain-Spanish reading of a round's system errors (`BatchReport.system_errors`).
 *
 * The server stores terse codes (`TIMEOUT`, `MANUAL_REVIEW`). Shown raw in the
 * round dashboard, a single expediente's `TIMEOUT` read as "the round timed
 * out" (COLBACH, 2026-09-29, a 1,173-expediente round with ONE slow
 * expediente). Every message here says it concerns that expediente only.
 */

export type SystemErrorText = { title: string; detail: string };

const REFERENCE_FETCH_PREFIX = "REFERENCE_FETCH_FAILED";

export function describeSystemError(error: string): SystemErrorText {
  if (error === "TIMEOUT") {
    return {
      title: "Tiempo de proceso agotado",
      detail:
        "Este expediente pasó del tiempo máximo de proceso por expediente y quedó sin veredicto. Solo afecta a este expediente; el resto de la ronda se procesó con normalidad. Se puede volver a procesar.",
    };
  }
  if (error === "WORKER_POOL_BROKEN") {
    return {
      title: "Procesamiento interrumpido",
      detail:
        "El proceso de la ronda se interrumpió antes de terminar este expediente (probablemente por falta de memoria). Se puede volver a procesar.",
    };
  }
  if (error.startsWith(REFERENCE_FETCH_PREFIX)) {
    const cause = error.slice(REFERENCE_FETCH_PREFIX.length).replace(/^:\s*/, "");
    return {
      title: "No se pudieron descargar los documentos",
      detail: `Los enlaces de custodia externa de este expediente fallaron${cause ? ` (${cause})` : ""}. Registra enlaces nuevos y vuelve a enviarlo.`,
    };
  }
  return { title: "Error inesperado al procesar este expediente", detail: error };
}

const ACTION_LABELS: Record<string, string> = {
  MANUAL_REVIEW: "Revisión manual",
};

export function describeSystemErrorAction(action: string): string {
  return ACTION_LABELS[action] ?? action;
}
